import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';

import { languageOptions } from './languageOptions';
import { LanguageSelect } from './LanguageSelect';
import type { LanguageEnum } from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

interface PassengerLanguagesContextFieldProps {
  fieldPath: string;
  primaryFieldPath: string;
  label: string;
}

export default function PassengerLanguagesContextField({
  fieldPath,
  primaryFieldPath,
  label,
}: PassengerLanguagesContextFieldProps) {
  return (
    <FormFieldController name={fieldPath}>
      {({ field: languagesField, fieldState }) => (
        // Two nested controllers rather than a setValue on the second path,
        // so both fields keep their own validation and dirty tracking.
        <FormFieldController name={primaryFieldPath}>
          {({ field: primaryField }) => (
            <FormFieldContainer>
              <DefaultFormFieldLayout
                label={label}
                error={fieldState.error?.message?.toString()}
                inputId={fieldPath}
              >
                <LanguageSelect
                  id={fieldPath}
                  options={languageOptions}
                  selected={(languagesField.value ?? []) as LanguageEnum[]}
                  primary={(primaryField.value ?? '') as LanguageEnum | ''}
                  onChange={(next) => {
                    languagesField.onChange(next.selected);
                    primaryField.onChange(next.primary);
                  }}
                />
              </DefaultFormFieldLayout>
            </FormFieldContainer>
          )}
        </FormFieldController>
      )}
    </FormFieldController>
  );
}
